import React, { useRef, useState, useEffect } from 'react';

import SatSignPad from '@components/common/satUI/SatSignPad';
import SatButton from '@components/common/satUI/SatButton';
import SatFollowText from '@components/common/satUI/SatFollowText';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';

import { getToday } from '@common/utils/date';

const LifePlannerSignPopup = props => {
  const {
    searchSignData,
    ownerName,
    onSave,
    empName,
    complete,
    signData,
    isShowContractName = true,
    userType,
    lpDeptYn,
  } = props;

  const followRef = useRef();
  const canvasNameRef = useRef();
  const canvasSignRef = useRef();

  const [isFollowTxtError, setIsFollowTxtError] = useState(false);

  const [signNameData, setSignNameData] = useState(''); // 성명
  const [signatureData, setSignatureData] = useState(''); // 서명

  const [isValid, setIsValid] = useState(false); // 따라쓰기 입력 여부
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  useEffect(() => {
    if (complete) {
      setIsValid(true);
    } else {
      if (isShowContractName) {
        followRef.current.onFocusInput();
      } else {
        setIsValid(true);
      }
    }

    // // 기존에 등록된 서명 조회
    if (!signData.signData || !signData.nameData) {
      searchSignData();
    }
  }, []);

  const handleButtonClick = () => {
    if (isShowContractName) {
      if ([followRef.current.getIsMatched()].filter(item => !item).length > 0) {
        setIsFollowTxtError(true);
        followRef.current.onFocusInput();
      }
    }
    if (!signNameData || !signatureData) {
      setIsErrorVisible(true);
    }

    if (isValid && signNameData && signatureData) {
      onSave(signNameData, signatureData); // 저장
    }
  };

  const handleMatched = res => {
    if (res) {
      setIsValid(true);
      setIsFollowTxtError(false);
      followRef.current.onFocusBlur();
    }
  };

  return (
    <React.Fragment>
      <div className="cont">
        <h3 className="layer-tit2">
          {$utils.checkLPText(userType) && !lpDeptYn
            ? '라이프파트너 성명 및 서명 (라이프파트너가 작성합니다.)'
            : '보험설계사 성명 및 서명 (보험설계사가 작성합니다.)'}
        </h3>
        <div className="modal-scroll-wrap" id="signPadScroll">
          {/* 11/23 - GA이고 옴니인 경우에만 따라쓰기 서명 */}
          {isShowContractName && (
            <>
              <p className="text-info4">
                아래의 입력 영역을 선택하여 키패드로 직접 입력해주세요.
              </p>
              <div className="txt-pad-wrap">
                {$utils.checkLPText(userType) && !lpDeptYn ? '라이프파트너' : '보험설계사'}{' '}
                {empName}
                (은)는 상품설명 내용에 대하여 보험계약자
                <SatFollowText
                  ref={followRef}
                  followText={ownerName}
                  onMatched={handleMatched}
                  complete={complete}
                />
                님께 설명하고 이 상품설명서를 교부 하였습니다.
              </div>
              <SatValidationErrMsg
                visible={isFollowTxtError}
                type="error"
                message="내용을 확인하고 따라쓰기를 해주세요."
              />
            </>
          )}

          <div className="info-box bg-yellow">
            <p className="text-info3 asterisk-type">
              {$utils.checkLPText(userType) && !lpDeptYn ? '라이프파트너' : '보험설계사'}{' '}
              서명은 최초 1회 등록이 필요하며, 등록된 서명은 청약문서의{' '}
              {$utils.checkLPText(userType) && !lpDeptYn ? '라이프파트너' : '보험설계사'}{' '}
              성명 및 서명란에 적용됩니다.
            </p>
            <p className="text-info3 asterisk-type">
              이미 등록된 서명이 존재하는 경우, 기존 서명을 재사용할 수 있으며,
              새로이 서명을 재등록할 수 있습니다. 이때, 청약문서에 적용되는
              서명은 최초 등록한 서명이 적용 됩니다.
            </p>
          </div>
          <div className="text-info4 w-360">
            등록일자 :{' '}
            {signData.signDate
              ? signData.signDate.substr(0, 4) +
                '.' +
                signData.signDate.substr(4, 2) +
                '.' +
                signData.signDate.substr(6, 2)
              : getToday()}
          </div>
          <div className="sign-pad-wrap">
            <SatSignPad
              canvasRef={canvasNameRef}
              name={empName}
              title={
                $utils.checkLPText(userType) && !lpDeptYn
                  ? '라이프파트너 성명 입력'
                  : '보험설계사 성명 입력'
              }
              error={
                isErrorVisible && !signNameData ? '성명을 입력해주세요.' : ''
              }
              onChange={value => setSignNameData(value)}
              signData={signData.nameData}
            />
            <SatSignPad
              canvasRef={canvasSignRef}
              name={'서명'}
              title={
                $utils.checkLPText(userType) && !lpDeptYn
                  ? '라이프파트너 서명 입력'
                  : '보험설계사 서명 입력'
              }
              error={
                isErrorVisible && !signatureData ? '서명을 입력해주세요.' : ''
              }
              onChange={value => setSignatureData(value)}
              signData={signData.signData}
            />
          </div>
        </div>
      </div>
      <div className="layer-footer">
        <SatButton
          styleClass={`btn-s blue btn-wide ${
            !isValid || !signNameData || !signatureData ? 'disabled' : ''
          }`}
          label={'확인'}
          onClick={() => handleButtonClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default LifePlannerSignPopup;
